import { Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PHProvider } from "../shared/PostHogProvider";
import { LandingPage } from "./pages/LandingPage";
import { ResultsPage } from "./pages/ResultsPage";
import "./analyze.css";

const queryClient = new QueryClient();

export function AnalyzeApp() {
  return (
    <PHProvider>
      <QueryClientProvider client={queryClient}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/results" element={<ResultsPage />} />
          <Route path="/demo/:exampleId" element={<ResultsPage />} />
          <Route path="/:uid" element={<ResultsPage />} />
        </Routes>
      </QueryClientProvider>
    </PHProvider>
  );
}
